import { initEssentialLinks } from "./essential-links.js";

export default function initModals(root = document) {
  console.log("INIT MODALS RUNNING");
  const triggers = root.querySelectorAll("[data-open-modal]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const id = trigger.getAttribute("data-open-modal");
      const modal = document.getElementById(id);
      if (!modal) return;

      openModal(modal, trigger);
    });
  });
}

function openModal(modal, trigger) {
  modal.removeAttribute("hidden");
  modal.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("is-modal-open");
document.body.classList.add("is-modal-open");

  document.dispatchEvent(
    new CustomEvent("modal:open", {
      detail: { id: modal.id },
    }),
  );

  // 🔥 force browser to register initial state
  requestAnimationFrame(() => {
    modal.classList.add("is-visible");
    initEssentialLinks(modal);

    // focus
    const autoFocus = modal.querySelector("[data-autofocus]");
    if (autoFocus) {
      autoFocus.focus();
    } else {
      const firstFocusable = modal.querySelector(
        'a, button, input, [tabindex]:not([tabindex="-1"])',
      );
      firstFocusable?.focus();
    }
  });

  trapFocus(modal);

  modal.querySelectorAll("[data-close]").forEach((el) => {
    el.onclick = () => closeModal(modal, trigger);
  });
}

function closeModal(modal, trigger) {
  modal.classList.remove("is-visible");

  document.dispatchEvent(
    new CustomEvent("modal:close", {
      detail: { id: modal.id },
    }),
  );

  setTimeout(() => {
    modal.setAttribute("hidden", "");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("is-modal-open");
document.body.classList.remove("is-modal-open");
  }, 200); // match CSS duration

  trigger?.focus();
}

function trapFocus(modal) {
  const focusable = modal.querySelectorAll(
    'a, button, input, [tabindex]:not([tabindex="-1"])',
  );

  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  modal.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      modal.querySelector("[data-close]")?.click();
    }

    if (e.key !== "Tab") return;

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
}
